import React from 'react'
import { Navigate } from 'react-router-dom'
import lazyLoad from '@helper/lazy-load'

const router = [
    {
        index: true,
        element: <Navigate to="/app/servicio"/>
    },
    {
        path: '/app/servicio',
        element: lazyLoad(() => import('@pages/servicio/components/main')),
        loader: () => ({ menuIndex: 4, key: 'servicio.servicio', icon: 'icon-kefu', show: true }),
        children: [
            {
                index: true,
                element: <Navigate to="/app/servicio/overview"/>
            },
            {
                path: '/app/servicio/overview',
                element: lazyLoad(() => import('@pages/servicio-overview/components/main')),
                loader: () => ({
                    menuIndex: 1,
                    key: 'servicio.overview',
                    activeMenu: '/app/servicio/overview',
                    show: true
                })
            },
            {
                path: '/app/servicio/monitoring',
                element: lazyLoad(() => import('@pages/servicio-monitoring/components/main')),
                loader: () => ({
                    menuIndex: 2,
                    key: 'servicio.monitoring',
                    activeMenu: '/app/servicio/monitoring',
                    show: true
                })
            },
            {
                path: '/app/servicio/chat-logs',
                element: lazyLoad(() => import('@pages/servicio-chat-logs/components/main')),
                loader: () => ({
                    menuIndex: 3,
                    key: 'servicio.chatLogs',
                    activeMenu: '/app/servicio/chat-logs',
                    show: true
                })
            },
            {
                path: '/app/servicio/call-logs',
                element: lazyLoad(() => import('@pages/servicio-call-logs/components/main')),
                loader: () => ({
                    menuIndex: 4,
                    key: 'servicio.callLogs',
                    activeMenu: '/app/servicio/call-logs',
                    show: true
                })
            },
            {
                path: '/app/servicio/todo',
                element: lazyLoad(() => import('@pages/servicio-todo/components/main')),
                loader: () => ({
                    menuIndex: 5,
                    key: 'servicio.todo',
                    activeMenu: '/app/servicio/todo',
                    show: true
                })
            },
            {
                path: '/app/servicio/message',
                element: lazyLoad(() => import('@pages/servicio-message/components/main')),
                loader: () => ({
                    menuIndex: 6,
                    key: 'servicio.message',
                    activeMenu: '/app/servicio/message',
                    show: true
                })
            },
            {
                path: '/app/servicio/offline-message',
                element: lazyLoad(() => import('@pages/servicio-offline-message/components/main')),
                loader: () => ({
                    menuIndex: 7,
                    key: 'servicio.offlineMessage',
                    activeMenu: '/app/servicio/offline-message',
                    show: true
                })
            },
            {
                path: '/app/servicio/scene-setting',
                element: lazyLoad(() => import('@pages/servicio-scene-setting/components/main')),
                loader: () => ({
                    menuIndex: 8,
                    key: 'servicio.sceneSetting',
                    activeMenu: '/app/servicio/scene-setting',
                    show: true
                })
            },
            {
                path: '/app/servicio/setting',
                element: lazyLoad(() => import('@pages/servicio-setting/components/main')),
                loader: () => ({
                    menuIndex: 9,
                    key: 'servicio.setting',
                    activeMenu: '/app/servicio/setting',
                    show: true
                })
            }
            // {
            //     path: '/app/servicio/phrase',
            //     element: lazyLoad(() => import('@pages/servicio-phrase/components/main')),
            //     loader: () => ({
            //         menuIndex: 5,
            //         key: 'servicio.phrase',
            //         icon: 'icon-kefu',
            //         activeMenu: '/app/servicio/phrase',
            //         show: true
            //     })
            // }
        ]
    }
]

export default router
